import {
  GridProps as MantineGridProps,
  Grid as MantineGrid,
  GridColProps as MantineGridColProps,
  GridCol as MantineGridCol,
} from '@mantine/core';

export type GridProps = MantineGridProps;
export type GridColProps = MantineGridColProps;

export const Grid = MantineGrid;
Grid.displayName = 'Grid';

export const GridCol = MantineGridCol;
GridCol.displayName = 'GridCol';

// Attach Col to Grid for Grid.Col syntax
Grid.Col = GridCol;
